import { usePersonInfo } from '@/data/Content/PersonInfo';
import { useSettings } from '@/data/Settings';
import { getExternalId } from '@/data/utils/externalId';
import { FacebookClientPayload } from '@/pages/api/tracking/facebook/facebookAPIUtils';
import { useFacebookClickIdentifiers } from 'presentation/events/hooks/useClickIdentifiers';
import { useTrackingStoreLocation } from 'presentation/events/hooks/useTrackingStoreLocation';
import { triggerFacebookCAPIEvent } from 'presentation/events/services/facebookService';
import { safeDecodeUrl } from 'presentation/events/utils/ga4Utils';
import { useCallback } from 'react';

interface FacebookEventParams {
	searchTerm: string;
	eventId: string;
	storeId: string;
}

export const useTrackSearchSubmitFacebook = () => {
	const { settings } = useSettings();
	const { userData } = settings;
	const { personInfo } = usePersonInfo();
	const { fbc, fbp } = useFacebookClickIdentifiers();
	const storeLocation = useTrackingStoreLocation();

	const sendFacebookEvent = useCallback(
		({ searchTerm, eventId, storeId }: FacebookEventParams) => {
			if (userData?.ENABLE_CAPI_TARGET_CALL !== 'true') return;

			const facebookPayload: FacebookClientPayload = {
				event_name: 'Search',
				fbc,
				fbp,
				test_event_code: userData?.FACEBOOK_TEST_CODE,
				event_id: eventId,
				event_source_url: safeDecodeUrl(window.location.href),
				storeId,
				custom_data: {
					email: personInfo?.email1,
					phone: personInfo?.phone1,
					firstName: personInfo?.firstName,
					lastName: personInfo?.lastName,
					city: storeLocation?.city,
					state: storeLocation?.state,
					zipCode: storeLocation?.zipCode,
					externalId: getExternalId(),
					search_string: searchTerm,
				},
			};

			triggerFacebookCAPIEvent(facebookPayload);
		},
		[
			fbc,
			fbp,
			storeLocation,
			personInfo?.email1,
			personInfo?.firstName,
			personInfo?.lastName,
			personInfo?.phone1,
			userData?.ENABLE_CAPI_TARGET_CALL,
			userData?.FACEBOOK_TEST_CODE,
		]
	);

	return { sendFacebookEvent };
};
